module.exports = "<h2>Line Chart</h2>\n<div echarts [options]=\"lineChartOptions\" class=\"chart\"></div>\n\n<h2>Bar Chart</h2>\n<div echarts [options]=\"barChartOptions\" class=\"chart\"></div>\n\n<h2>Pie Chart</h2>\n<div echarts [options]=\"pieChartOptions\" class=\"chart\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/charts.component.html
// module id = ./src/app/charts/charts.component.html
// module chunks = main